export const toggleTabs = {
    data() {
        return {

        }
    },
    methods: {
        toggleTabs(arr, tab, callback=false) {
            if (arr[tab].selected) {
                return;
            }
            for (let i in arr) {
                if (arr[i].selected) {
                    arr[i].selected = false;
                }
            }
            arr[tab].selected = true;
            if (callback) {
                callback();
            }
        }
    }
}